let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ffitL")).then(() => parcelRequire('kSre2'));